(() => {
  let brandLogoEl = document.querySelector(".brand-logo");

  async function getVariantBrandSection(variantId = null) {
    let url = "?sections=variant-brand-logo";

    if (variantId) {
      url = url + `&variant=${variantId}`;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const result = await response.json();
      setVariantBrandSection(result);
    } catch (error) {
      console.error(error.message);
    }
  }

  function setVariantBrandSection(sections) {
    let htmlString = sections["variant-brand-logo"];
    htmlString = htmlString.replace('<div id="shopify-section-variant-brand-logo" class="shopify-section">', '');
    htmlString = htmlString.replace('</div>', '');

    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    const newImg = div.firstChild;

    brandLogoEl.replaceWith(newImg);
    brandLogoEl = newImg;
  }

  document.addEventListener("variant-changed", (e) => {
    const variant = e.detail;
    if (brandLogoEl) {
      getVariantBrandSection(variant.id);
    }
  });

  class TruncatedDescription extends HTMLElement {
    constructor() {
      super();
      this._internals = this.attachInternals();
      this.controller = this.querySelector(".controller");
      this.description = this.querySelector(".collection__description");
      this.descriptionLast = this.description.lastChild;
    }

    connectedCallback() {
      this.controller.addEventListener("click", (e) => {
        this.open = !this.open;

        if (this.open)  {
          this.controller.textContent = "read less";

          // Move controller to inside the description
          if (this.descriptionLast.nodeType == 3) {
            this.descriptionLast.after(this.controller);
          } else {
            this.descriptionLast.append(this.controller);
          }
        } else {
          this.controller.textContent = "read more";

          // Move controller to outside the description
          this.description.after(this.controller); 
        }
      });
    }

    get open() {
      return this._internals.states.has("open");
    }

    set open(flag) {
      if (flag) {
        this._internals.states.add("open");
      } else {
        this._internals.states.delete("open");
      }
    }
  }

  customElements.define("truncated-description", TruncatedDescription);
})();